import * as React from 'react';
import { styled, ThemeProvider, useTheme } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { Box } from '@mui/material';

export const Bs4HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
)) (({ theme, boxsx }) => { 
  return({
  [`& .${tooltipClasses.tooltip}`]: {
    ...boxsx,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: boxsx?.backgroundColor,
    "&::before": {
        ...boxsx,    
      }
  },
})});

export const Bs4Tooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    //boxShadow: theme.shadows[1],
    //fontSize: 11,
  },
}));

export const Bs4Tooltip01 = (props) => {
  const {title, ...other} = props;

  if (!String(title).trim()) return (
    <>
      {props.children}
    </>
  )

  return (
    <Bs4Tooltip
      title={<div dangerouslySetInnerHTML={{__html: props.title}}/>}
      {...other}
    >
      {props.children}
    </Bs4Tooltip>
  )
};

export default Bs4Tooltip;